import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faHome,
  faUsers,
  faSitemap,
  faBars,
  faPowerOff,
  faPlus,
  faSearch,
  faPen,
  faTrash,
  faPlusSquare,
  faMinusSquare,
  faEye,
  faTimes,
  faCheck,
  faSave,
  faPencil
} from '@fortawesome/free-solid-svg-icons'

import {
  faSquarePlus,
  faSquareMinus
} from '@fortawesome/free-regular-svg-icons'

// Add icons to the library
library.add(
  faHome,
  faUsers,
  faSitemap,
  faBars,
  faPowerOff,
  faPlus,
  faSearch,
  faPen,
  faTrash,
  faPlusSquare,
  faMinusSquare,
  faEye,
  faTimes,
  faCheck,
  faSave,
  faPencil,
  faBars,
  faPowerOff,
  faPlus,
  faSearch,
  faPen,
  faTrash,
  faSquarePlus,
  faSquareMinus
)

export function setupFontAwesome(app) {
  app.component('FontAwesomeIcon', FontAwesomeIcon)
}
